import { FilterCollectionContext } from '@paperstac/common/lib/components/FilterCollectionProvider';
import { SortCollectionContext } from '@paperstac/common/lib/components/SortCollectionProvider';
import Box from '@paperstac/ui/lib/Box';
import Flex from '@paperstac/ui/lib/Flex';
import Input from '@paperstac/ui/lib/form/Input';
import Select from '@paperstac/ui/lib/form/Select';
import React from 'react';
import { LISTING_SORTS, LISTING_STATUS } from './MyListingsPageProvider';

const Meta = React.memo((props) => {
  const { addExactFilter, addFuzzyFilter } = React.useContext(FilterCollectionContext);
  const { setSort, sortLabel } = React.useContext(SortCollectionContext);
  const [address, setAddress] = React.useState('');
  const [status, setStatus] = React.useState('');

  const handleAddressChange = React.useCallback(({ target: { value } }) => setAddress(value), []);
  const handleStatusChange = React.useCallback(({ target: { value } }) => setStatus(value), []);
  const handleSortChange = React.useCallback(({ target: { value } }) => setSort(...LISTING_SORTS[value]), [setSort]);

  React.useEffect(() => {
    addFuzzyFilter('address', 'addresses', address);
  }, [addFuzzyFilter, address]);

  React.useEffect(() => {
    addExactFilter('status', 'status', status);
  }, [addExactFilter, status]);

  return (
    <Flex flexDirection={['column', 'row']} {...props}>
      <Box
        sx={{
          mr: [0, 3],
          mb: [2, 0],
        }}
      >
        <Box as="label" htmlFor="address" fontWeight="bold">
          Property Address:
        </Box>
        <Input
          id="address"
          onChange={handleAddressChange}
          value={address}
          placeholder="e.g. 123 Main St"
          width={['100%', 200]}
        />
      </Box>
      <Box
        sx={{
          flexGrow: [0, 1],
          mr: [0, 3],
          mb: [2, 0],
        }}
      >
        <Box as="label" htmlFor="status" fontWeight="bold">
          Listing Status:
        </Box>
        <Select id="status" onChange={handleStatusChange} value={status} width={['100%', 'auto']}>
          <option value="">All</option>
          <option value={LISTING_STATUS.ACTIVE}>Active</option>
          <option value={LISTING_STATUS.INACTIVE}>Inactive</option>
          <option value={LISTING_STATUS.NEEDS_ATTENTION}>Needs Attention</option>
        </Select>
      </Box>
      <Box>
        <Box as="label" htmlFor="sort" fontWeight="bold">
          Sort By:
        </Box>
        <Select id="sort" onChange={handleSortChange} value={sortLabel} width={['100%', 'auto']}>
          {Object.keys(LISTING_SORTS).map((label) => (
            <option key={label} value={label}>
              {label}
            </option>
          ))}
        </Select>
      </Box>
    </Flex>
  );
});

Meta.propTypes = {};

Meta.defaultProps = {};

Meta.displayName = 'Meta';

export default Meta;
